// @codekit-prepend "../../node_modules/jquery/dist/jquery.js";
// @codekit-prepend "../../node_modules/foundation-sites/dist/js/foundation.min.js";

jQuery(function ($) {

	// Call the pretty Foundation scripts
	$(document).foundation();

	// Make the entire div containing link clickable.
	$(".link-box").click(function(){
		if($(this).find("a").length){
	       window.location.href = $(this).find("a:first").attr("href");
	       var $a = $(this).find("a:first");
	       window.open($a.attr("href"), $a.attr("target") || '_self');
	       return false;
		}
	});

	// Insert screen reader text for pagination on archive pages.
	$(".page-numbers a:not(.next)").each(function() {
		$(this).prepend('<span class="sr-only">Page number </span>');
	});

	// Check external links and add class.
	function link_is_external(link_element) {
		if( link_element.href && !link_element.href.includes('mailto:') && !link_element.href.includes('tel:') ) {
			return (link_element.host !== window.location.host);
		}
	}

	$('a').each(function() {
		if (link_is_external(this) && !$(this).hasClass('document-block__link') && !$(this).hasClass('content-image__link') && !$(this).hasClass('social-footer-list__link') ) {
			$(this).addClass('external');
			$(this).attr('target', '_blank');
			$(this).attr('rel', 'noopener');
		}
	})
	
	// Detect PDFs in links and add attributes.
    function link_is_document(link_document) {
        if (link_document.href.includes('.pdf') || link_document.href.includes('.docx') ) {
            return true;
        }
    }

	$('a').each(function() {
        if (link_is_document(this) && !$(this).hasClass('document-block__link')) {
            $(this).addClass('pdf');
            $(this).attr('aria-label', 'This is a link to a PDF Document');
        }
    })

	// Add aria-labels to required form fields
	$('.frm_required_field .frm_required').each(function() {
		$(this).parent().attr('aria-label', 'This is a required field');
		$(this).text('* (required)');
	})

	// Wrap any table with table-scroll wrapper
	$('table').wrap('<div class="table-scroll"></div>');

	// Wrap any iframe with resposive-embed wrapper
	$('.page-section-block__content iframe').wrap('<div class="responsive-embed"></div>');
	$('.classic-editor-block iframe').wrap('<div class="responsive-embed"></div>');

	// Remove Hash from in page links
	function removeHash () { 
		history.pushState("", document.title, window.location.pathname + window.location.search);
	}

	$('.page-section-block__menu a').on('click', function(){
		setTimeout( ()=> {
			removeHash();
		}, 5)
	});
});
